import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSubmitComponent } from './input-submit.component';

@NgModule({
  declarations: [InputSubmitComponent],
  imports: [
    CommonModule
  ],
  exports: [
    InputSubmitComponent
  ]
})
export class InputSubmitModule { }
